// extracted by mini-css-extract-plugin
export default {"recommender":"WL-z","recommenderCard":"XL-z","recommendationsNotMobileBadge":"YL-z","rowHasBadge":"ZL-z"};